<template>
  <div
    :class="{'toast--out': !isVisible}"
    class="toast relative b-radius--5 flex flex--center__vert mar--top__1 pad--2">
    <div class="toast--icon color--success mar--right__1" v-if="this.type === 'success'" >
      <ion-icon name="checkmark-circle-outline" />
    </div>
    <div class="toast--icon color--warning mar--right__1" v-if="this.type === 'warning'" >
      <ion-icon name="alert" />
    </div>
    <div class="toast--icon color--danger mar--right__1" v-if="this.type === 'error'" >
      <ion-icon name="close-circle-outline" />
    </div>
    <div class="flex flex--column">
      <div class="font--s16 font--w700">{{
          this.title || 'Fehler'
        }}</div>
      <div
        @click="closeToast"
        class="absolute clickable top--1 right--2 font--s2">
        <ion-icon name="close" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Toast',
  props: ['type', 'title', 'message', 'toastID'],
  data() {
    return {
      isVisible: true,
      timeout: null,
    };
  },
  methods: {
    closeToast() {
      this.isVisible = false;
      setTimeout(() => {
        this.$store.commit('deleteToast', this.toastID);
      }, 600);
    },
  },
  mounted() {
    setTimeout(() => {
      this.closeToast();
    }, 5000);
  },
};
</script>
